export const GET_HIRE_DECISION_LIST="GET_HIRE_DECISION_LIST"
export const GET_HIRE_DECISION_LIST_SUCCESS="GET_HIRE_DECISION_LIST_SUCCESS"
export const GET_HIRE_DECISION_LIST_FAILED="GET_HIRE_DECISION_LIST_FAILED"